
import { z } from "zod";

export const PvSystemOverridePriceTypeValues = ["Panel", "System"] as const;
export const PvSystemOverridePriceTypeSchema = z.enum(PvSystemOverridePriceTypeValues);
export const PvSystemOverridePriceType = PvSystemOverridePriceTypeSchema.enum;
export type PvSystemOverridePriceType = (typeof PvSystemOverridePriceTypeValues)[number];
